module.exports = __webpack_public_path__ + "static/media/action-required.44044e4e.svg";